import React, { useState } from "react";
import './Addadmin.styles.scss';
import {showToast} from "../../../../helpers/showToast";

const AddAdmin = ({ onAddAdmin, handleCancel }) => {
  const [newAdmin, setNewAdmin] = useState({
    username: "",
    password: "",
    confirmPassword: "",
      phoneNumber: "",

  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAdmin({
      ...newAdmin,
      [name]: value,
    });
  };

  const clearForm = () => {
    setNewAdmin({
      username: "",
      password: "",
      confirmPassword: "",
        phoneNumber: "",
    });
  };

  const handleAddAdmin = (e) => {
    if (e) {
      e.preventDefault();
    }
    const validCharactersRegex = /^[a-zA-Z0-9$_]+$/;
    if (!validCharactersRegex.test(newAdmin.username)) {

      showToast({
        toastOptions: {type: "error"},
        data: {
          text: "Username should only contain English letters (both uppercase and lowercase), numbers, '$', or '_'."
        }
      });
      return;
    }

    if (newAdmin.username.length < 4) {
      showToast({
        toastOptions: {type: "error"},
        data: {
          text: "Username must be at least 4 characters long."
        }
      });

      return;
    }



      if (newAdmin.password !== newAdmin.confirmPassword) {
      showToast({
        toastOptions: {type: "error"},
        data: {
          text: "Password and Confirm Password do not match."
        }
      });
      return;
    }

    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}/;
    if (!passwordRegex.test(newAdmin.password)) {
      showToast({
        toastOptions: {type: "error"},
        data: {
          text: "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character."
        }
      });
      return;
    }

      const phoneRegex = /^[0-9]{10}$/;
      if (!phoneRegex.test(newAdmin.phoneNumber)) {
          showToast({
              toastOptions: { type: "error" },
              data: {
                  text: "Please enter a valid phone number",
              },
          });
          return;
      }

    onAddAdmin(newAdmin);
    clearForm();
  };

  return (
    <form autoComplete="off">
      <div className="add-admin-form">
        <h3>Add New Admin</h3>

        <div className="form-group">
          <input
              type="text"

              placeholder="Username"
              name="username"
              value={newAdmin.username}
              autoComplete="new-username"
              autoCorrect="off"
              onChange={handleInputChange}
              className="form-input"
          />
        </div>

        <div className="form-group">
          <input
              type="password"
              placeholder="Password"
              name="password"
              autoComplete="new-password"
              autoCorrect="off"
              value={newAdmin.password}
              onChange={handleInputChange}
              className="form-input"
          />
        </div>

        <div className="form-group">
          <input
              type="password"
              placeholder="Confirm Password"
              name="confirmPassword"
              autoComplete="new-password"
              autoCorrect="off"
              value={newAdmin.confirmPassword}
              onChange={handleInputChange}
              className="form-input"
          />
        </div>

          <div className="form-group">
              <input
                  type="text"
                  placeholder="07xxxxxxxx"
                  name="phoneNumber"
                  value={newAdmin.phoneNumber}
                  autoComplete="new-phone"
                  onChange={handleInputChange}
                  className="form-input"
              />
          </div>


          <div className="form-buttons">
          <button type="submit" className="btn btn-primary" onClick={handleAddAdmin}>
            Add Admin
          </button>
          <button
              onClick={() => {
                clearForm();
                handleCancel();
              }}
              className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddAdmin;
